import { Link } from 'react-router-dom';

/**
 * Pied drawer U4 — actions métier + CTA Cockpit.
 * Point d’entrée unique des actions (pas de menu ⋮ ligne).
 */
export default function MaterielDrawerFooter({
  item,
  onAssign,
  onStock,
  actionBusy = false,
}) {
  if (!item) return null;

  const nom = item?.commercant?.nom && String(item.commercant.nom).trim();
  const id = item?.commercantId;
  const isAssigned = item.status === 'AFFECTE' && Boolean(nom);
  const assignLabel = isAssigned
    ? 'Changer de point de vente'
    : 'Affecter à un point de vente';

  return (
    <footer className="border-t border-gray-100 px-4 py-3 bg-gray-50 space-y-2">
      <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
        Actions
      </p>
      <div className="flex flex-col gap-2">
        <button
          type="button"
          disabled={actionBusy}
          onClick={onAssign}
          className="w-full px-3 py-2 text-sm font-medium rounded-md border border-primary-200 bg-white text-primary-800 hover:bg-primary-50 disabled:opacity-60"
        >
          {assignLabel}
        </button>
        {isAssigned ? (
          <button
            type="button"
            disabled={actionBusy}
            onClick={onStock}
            className="w-full px-3 py-2 text-sm font-medium rounded-md border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 disabled:opacity-60"
          >
            Remettre en stock
          </button>
        ) : null}
        {isAssigned && id ? (
          <Link
            to={`/commercants/${id}?tab=impression`}
            className="inline-flex w-full items-center justify-center px-3 py-2 text-sm font-medium rounded-md bg-primary-600 text-white hover:bg-primary-700"
          >
            Configurer l&apos;impression du point de vente
          </Link>
        ) : null}
      </div>
      {isAssigned && id ? (
        <p className="text-[11px] text-gray-500 text-center">
          Cockpit Impression existant de {nom}.
        </p>
      ) : null}
    </footer>
  );
}
